import React from "react";
import { Button } from "../../components/ui/button";
import { Sparkles, Loader2 } from "lucide-react";

function buttonLabel(analyzing, hasInsight) {
  if (analyzing) return <><Loader2 className="h-3 w-3 animate-spin mr-2" /> Analyzing</>;
  return hasInsight ? "Re-Analyze" : "Analyze with AI";
}

export default function AIInsightPanel({ insight, analyzing, onAnalyze }) {
  return (
    <div className="border border-[#27272A] bg-[#08080A] rounded-sm p-4">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <Sparkles className="h-3.5 w-3.5 text-[#FF9900]" />
          <span className="text-[10px] tracking-[0.25em] uppercase text-[#FF9900] font-semibold">AI Coach Insight</span>
        </div>
        <Button data-testid="ai-analyze-btn" size="sm" onClick={onAnalyze} disabled={analyzing}
          className="bg-[#FF9900] hover:bg-[#FF9900]/90 text-black rounded-sm h-7 text-[10px] tracking-wider font-semibold">
          {buttonLabel(analyzing, !!insight)}
        </Button>
      </div>
      {insight ? (
        <div data-testid="ai-insight-text" className="text-sm text-[#F8F9FA] whitespace-pre-wrap leading-relaxed">{insight}</div>
      ) : (
        <div className="text-xs text-[#71717A]">Save your notes/emotion and click &ldquo;Analyze&rdquo; to get an AI coach review of this trade.</div>
      )}
    </div>
  );
}
